import React, { useEffect } from "react";

export default function Scroll() {
  useEffect(() => {
    const toTopBtn = document.getElementById("toTopBtn");

    const handleScroll = () => {
      if (document.documentElement.scrollTop > 300) {
        toTopBtn.style.display = "block";
      } else {
        toTopBtn.style.display = "none";
      }
    };

    const scrollToTop = () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    };

    toTopBtn.addEventListener("click", scrollToTop);
    window.addEventListener("scroll", handleScroll);

    return () => {
      toTopBtn.removeEventListener("click", scrollToTop);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return null; // 表示する要素は不要なので null を返す
}
